// extracted by mini-css-extract-plugin
export var callCard = "_nn-0";
export var callMessageButton = "_nn-1";
export var helpIcon = "_nn-3";
export var helpIconContainer = "_nn-4";
export var verticalDivider = "_nn-2";